import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { OptionProps } from '../../NavigationSlider'

type UseContextualNavigationSliderProps = {
  options: OptionProps[]
  contextAttribute: string
}

const useContextualNavigationSlider = ({
  options,
  contextAttribute
}: UseContextualNavigationSliderProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const location = useLocation()

  const [currentIndex, setCurrentIndex] = useState(0)

  const conxtextParam = searchParams.get(contextAttribute)

  const selectedContext = options[currentIndex]?.value
    ? options[currentIndex]?.value?.toLowerCase()
    : ''

  useEffect(() => {
    if (!options?.length || !options) return

    const setInitialContext = () => {
      searchParams.set(contextAttribute, options[0].value ?? '')
      setSearchParams(searchParams, { replace: true, state: location.state })
    }

    if (!conxtextParam) {
      setInitialContext()
      return
    }

    const index = options.findIndex(
      (option) => option.value?.toLowerCase() === conxtextParam?.toLowerCase()
    )
    if (index >= 0) {
      setCurrentIndex(index)
    } else {
      setInitialContext()
    }
  }, [
    conxtextParam,
    setCurrentIndex,
    options,
    searchParams,
    contextAttribute,
    setSearchParams,
    location.state
  ])

  const onNextClickHandler = () => {
    const totalPages = options.length

    const newIndex =
      currentIndex === totalPages - 1 ? currentIndex : currentIndex + 1

    searchParams.set(contextAttribute, options[newIndex].value ?? '')

    setSearchParams(searchParams, { replace: true, state: location.state })
  }

  const onPrevClickHandler = () => {
    const newIndex = currentIndex === 0 ? currentIndex : currentIndex - 1

    searchParams.set(contextAttribute, options[newIndex].value ?? '')

    setSearchParams(searchParams, { replace: true, state: location.state })

    setCurrentIndex(newIndex)
  }

  const getDisabledArrow = (): 'prev' | 'next' | undefined => {
    if (currentIndex === 0) {
      return 'prev'
    }
    if (currentIndex === options.length - 1) {
      return 'next'
    }

    return undefined
  }

  const disabledArrow = getDisabledArrow()

  const formattedOptions = options.map((option) => ({
    ...option,
    value: option.label ?? ''
  }))

  return {
    onNextClick: onNextClickHandler,
    onPrevClick: onPrevClickHandler,
    currentIndex,
    disabledArrow,
    selectedContext,
    options: formattedOptions
  }
}

export default useContextualNavigationSlider
